import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProjectService } from './../../core/services/project.service';

export type UnitType = 'weight' | 'length' | 'weightT';

@Pipe({
    name: 'unit',
    standalone: false
})
export class UnitPipe implements PipeTransform {
  constructor(private projectService: ProjectService, private translate: TranslateService) {}

  public transform(value: number, type: UnitType, bracket: boolean): any {
    if (
      this.projectService.getState().options &&
      this.projectService.getState().options.unit === 'lb'
    ) {
      if (type === 'weight') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_lb') as string}]`
            : ` ${this.translate.instant('units_lb') as string}`)
        );
      } else if (type === 'length') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_in') as string}]`
            : ` ${this.translate.instant('units_in') as string}`)
        );
      } else if (type === 'weightT') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_lb') as string}]`
            : ` ${this.translate.instant('units_lb') as string}`)
        );
      }
    } else if (
      this.projectService.getState().options &&
      this.projectService.getState().options.unit === 'mm'
    ) {
      if (type === 'weight') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_kg') as string}]`
            : ` ${this.translate.instant('units_kg') as string}`)
        );
      } else if (type === 'weightT') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_T') as string}]`
            : ` ${this.translate.instant('units_T') as string}`)
        );
      } else if (type === 'length') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_mm') as string}]`
            : ` ${this.translate.instant('units_mm') as string}`)
        );
      }
    } else if (
      this.projectService.getState().options &&
      this.projectService.getState().options.unit === 'cm'
    ) {
      if (type === 'weight') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_kg') as string}]`
            : ` ${this.translate.instant('units_kg') as string}`)
        );
      } else if (type === 'weightT') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_T') as string}]`
            : ` ${this.translate.instant('units_T') as string}`)
        );
      } else if (type === 'length') {
        return (
          value +
          (bracket
            ? ` [${this.translate.instant('units_cm') as string}]`
            : ` ${this.translate.instant('units_cm') as string}`)
        );
      }
    } else {
      return value;
    }
  }
}
